module.exports = __webpack_public_path__ + "img/payCost.58b596ec.png";